import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

const CustomPopup = ({ visible, onClose, title, message, type = "info" }) => {
  if (!visible) return null;

  const getIconAndColor = () => {
    switch (type) {
      case "error":
        return { icon: faTimes, color: "#EF4444" };
      case "warning":
        return { icon: faInfoCircle, color: "#F59E0B" };
      case "success":
        return { icon: faInfoCircle, color: "#10B981" };
      default:
        return { icon: faInfoCircle, color: "#3B82F6" };
    }
  };

  const { icon, color } = getIconAndColor();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-6 z-50">
      <div className="w-full max-w-md bg-white rounded-2xl p-5 shadow-lg border border-gray-200">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
            <FontAwesomeIcon icon={icon} className="text-xl" color={color} />
            <h2 className="text-lg font-bold text-gray-800 ml-2">{title}</h2>
          </div>

          <button onClick={onClose} className="p-1">
            <FontAwesomeIcon icon={faTimes} className="text-lg text-gray-600" />
          </button>
        </div>

        {/* Message */}
        <p className="text-gray-700 leading-6 mb-4">
          {message}
        </p>

        {/* Action Button */}
        <button
          onClick={onClose}
          className="w-full bg-red-500 text-white py-3 rounded-xl font-semibold mt-2"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default CustomPopup;
